cockpitApp.directive('menuMain', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/menu/main',
    controllerAs: 'menuMainCtrl',
    controller: 'menuMainController'
  };
});
